import { e, p, mo } from './encrypt.util';
import { m, d } from './date.util';

export const cache = k => ({
  'if-none-match': e(d().toString(), `${k}${m()}`, {
    mode: mo,
    padding: p,
  }).toString(),
});
